import { useQuery } from 'react-query';
import { getCurrentPaymentPlan } from '@features/payments';
import { currentPlanKey } from '@features/payments/constants';
import axiosInstance from '@server/axiosInstance';

type UseGetCurrentPlanParams = {
  companyId?: number;
};

export const useGetCurrentPlan = (params?: UseGetCurrentPlanParams) => {
  const { data: currentPlanData, isLoading: isCurrentPlanLoading } = useQuery({
    queryKey: params?.companyId ? [currentPlanKey, { company_id: params.companyId }] : [currentPlanKey],

    queryFn: () => {
      const queryParams = params?.companyId ? { params: { company_id: params.companyId } } : {};
      return axiosInstance
        .get(getCurrentPaymentPlan, queryParams)
        .then((res) => res.data);
    },
     refetchOnWindowFocus: false,
  });

  return {
    currentPlanData,
    isCurrentPlanLoading,
  };
};
